import { InvoiceCardSkeleton } from "./InvoiceCardSkeleton";

interface InvoiceListSkeletonProps {
  count?: number;
}

export const InvoiceListSkeleton = ({ count = 5 }: InvoiceListSkeletonProps) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <InvoiceCardSkeleton key={i} />
      ))}
    </div>
  );
};
